import React from 'react';

export default ({ component }) => <div style={{ paddingBottom: component.space }}/>;